import { jsx as t, jsxs as f } from "react/jsx-runtime";
import { X as u } from "lucide-react";
import { forwardRef as i } from "react";
const m = {
  display: "flex",
  flexDirection: "column",
  flexShrink: 0,
  height: "100%",
  backgroundColor: "var(--bg-surface)",
  color: "var(--text-primary)",
  overflow: "hidden"
}, g = i(function({ side: e = "right", width: r = 240, className: a, style: o, children: l, ...s }, d) {
  const c = e === "right" ? "borderLeft" : "borderRight";
  return /* @__PURE__ */ t(
    "aside",
    {
      ref: d,
      className: ["ls-side-panel", a].filter(Boolean).join(" "),
      style: {
        ...m,
        width: r,
        [c]: "1px solid var(--border-subtle)",
        ...o
      },
      ...s,
      children: l
    }
  );
}), S = i(
  function({ title: e, description: r, onClose: a, closeLabel: o = "Close", className: l, style: s, children: d, ...c }, p) {
    return /* @__PURE__ */ f(
      "div",
      {
        ref: p,
        className: ["ls-side-panel-header", l].filter(Boolean).join(" "),
        style: {
          padding: "var(--space-4)",
          borderBottom: "1px solid var(--border-subtle)",
          display: "flex",
          alignItems: "flex-start",
          gap: "var(--space-3)",
          flexShrink: 0,
          ...s
        },
        ...c,
        children: [
          /* @__PURE__ */ f("div", { style: { flex: 1, minWidth: 0 }, children: [
            e ? /* @__PURE__ */ t(
              "h2",
              {
                style: {
                  margin: 0,
                  fontSize: "var(--text-md)",
                  fontWeight: "var(--font-weight-semibold)",
                  color: "var(--text-primary)",
                  lineHeight: 1.3
                },
                children: e
              }
            ) : null,
            r ? /* @__PURE__ */ t(
              "p",
              {
                style: {
                  margin: 0,
                  marginTop: "var(--space-1)",
                  fontSize: "var(--text-sm)",
                  color: "var(--text-secondary)"
                },
                children: r
              }
            ) : null,
            d
          ] }),
          a ? /* @__PURE__ */ t(
            "button",
            {
              type: "button",
              "aria-label": o,
              onClick: a,
              style: {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: 28,
                height: 28,
                borderRadius: "var(--radius-md)",
                border: "1px solid transparent",
                background: "transparent",
                color: "var(--text-secondary)",
                cursor: "pointer"
              },
              children: /* @__PURE__ */ t(u, { size: 14, "aria-hidden": "true" })
            }
          ) : null
        ]
      }
    );
  }
), v = {
  padding: "var(--space-4)",
  flex: 1,
  minHeight: 0,
  overflowY: "auto",
  fontSize: "var(--text-sm)",
  color: "var(--text-primary)"
}, P = i(
  function({ className: e, style: r, ...a }, o) {
    return /* @__PURE__ */ t(
      "div",
      {
        ref: o,
        className: ["ls-side-panel-body", e].filter(Boolean).join(" "),
        style: { ...v, ...r },
        ...a
      }
    );
  }
), b = {
  padding: "var(--space-3) var(--space-4)",
  borderTop: "1px solid var(--border-subtle)",
  flexShrink: 0,
  background: "var(--bg-surface)"
}, j = i(
  function({ className: e, style: r, ...a }, o) {
    return /* @__PURE__ */ t(
      "div",
      {
        ref: o,
        className: ["ls-side-panel-footer", e].filter(Boolean).join(" "),
        style: { ...b, ...r },
        ...a
      }
    );
  }
);
export {
  g as S,
  P as a,
  j as b,
  S as c
};
//# sourceMappingURL=SidePanel-Djuk8hmu.js.map
